export enum PillVariant {
    STRONG = 'strong',
    CURRENT = 'current',
    SUBTLE = 'subtle',
}

export enum PillSize {
    MEDIUM = 'medium',
    SMALL = 'small',
}
